import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Router } from "react-router-dom";

//CSS
import "../assets/css/index.css";
import "../assets/css/fonts.css";
import "../assets/css/mobile.css";
import "../global.css";
import {
  useThemeContext,
} from "../assets/theme/ThemeContextProvider";
import { PageLoader } from "../components";
import { Toaster } from "sonner";

// Routes
import Routes from "../config/routeConfig";
import { getSystemThemePref, isFlozyMobileApp } from "../utils";
import NoNetworkConnection from "../components/NoInternetConnection";
import useWindowSize from "../hooks/useWindowSize";
import history from "../config/history";

// Create QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 seconds
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {  // Define Dispatch
  const dispatch = useDispatch();
  const { theme, mode } = useThemeContext();
  useWindowSize()

  const [embedPageSettings, setEmbedPageSettings] = useState({
    bgColor: mode === "light" ? "#fff" : "#0C1019",  
    textColor: mode === "light" ? "#0F172A" : "#fff", 
    primaryColor: "#2563EB",
    primaryTextColor:"#2563EB"
  });

  useEffect(() => {
    window.addEventListener('message', function (event) {
      if (event?.data?.pageSettings) {
        setEmbedPageSettings(event?.data?.pageSettings)
      }
    });
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <Router history={history}>
        <Routes />
        <Toaster richColors position="top-right" />
        <NoNetworkConnection />
      </Router>
    </QueryClientProvider>
  );
}

export default App;
